module.exports = new __parcel__URL__("battleroyale_placing_button_inactive.b9fb2586.png").toString();